import { useMutation, useQueryClient } from '@tanstack/react-query'
import { bulkDeleteLocationOverrideRules } from '../../../api/plan-location-override-rules-api'
import type { BulkDeleteLocationOverrideRulesRequestDto } from '../../../api/dto/plan-location-override-rules.dto'
import { LOCATION_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanLocationOverride/hooks/useGetLocationOverrideRules'

export function useBulkDeleteLocationOverrideRules() {
  const queryClient = useQueryClient()

  return useMutation<void, unknown, BulkDeleteLocationOverrideRulesRequestDto>({
    mutationFn: (body) => bulkDeleteLocationOverrideRules(body),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [LOCATION_OVERRIDE_RULES_QUERY_KEY],
      })
    },
  })
}
